import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";

import UpdateTochtForm from "./UpdateTochtForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import UpdateTochtPageHelper from "./UpdateTochtPageHelper";
import GenerateGuid from "../../../util/guid";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";
import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";

class UpdateTochtPage extends ScrollToFirstErrorComponent {
	constructor(props, context) {
		super(props, context, true);

		this.filesHelper = null;
		this.state = {
			model: {
				validatiestatusses: [],
				deelnamePrijzen: [],
				lussen: [],
				gemeenten: []
			},
			errors: null,
			hasUnsavedChanges: false,
			disabled: false,
			hoofdgemeenten: [],
			draggable: true,
			center: null,
			mapKey: GenerateGuid(),
			tooltip: false,
			showAnbPopup: false,
			showVoorzieningenPopup: false,
			scrollToTop: false,
			shouldScrollToFirstError: false,
			mapId: GenerateGuid(),
			fileComponents: {}
		};

		this.pageHelper = new UpdateTochtPageHelper(this, redirector);
		this.testFiller = new EasterEggHandler(this, pageConstants.WIJZIG_TOCHT);
	}

	componentDidMount = () => {
		const params = this.props.match.params;
		const modelId = params.modelId;

		if (this.props.shouldRedirect)
			redirector.goTo(`e-loket/organisator/${modelId}/false`);
		else {
			this.testFiller.bind();
			super.componentDidMount();
			this.pageHelper.init();
			window.parent.scrollTo(0, 0);
			this.setState({
				scrollToTop: false
			});
		}
	};

	componentWillUnmount() {
		this.state = {
			model: null
		};
	}
	componentDidUpdate = () => {
		super.componentDidUpdate();
		if (this.state.scrollToTop) {
			window.parent.scrollTo(0, 450);
			this.setState({
				scrollToTop: false
			});
		}
	};
	handleOnUploadFiles = (component, files) => this.filesHelper.uploadFiles(component, files);
	handleOnDeleteFile = (component, file) => this.filesHelper.deleteOneFile(component, file);
	handleOnSave = () => this.pageHelper.save();
	handleOnChange = event => this.pageHelper.change(event);
	handleOnChangeStartplaats = event => this.pageHelper.changeStartplaats(event);
	handleOnChangeRadio = event => this.pageHelper.changeRadio(event);
	handleOnChangeDeelnamePrijs = (index, event) => this.pageHelper.changeDeelnamePrijs(index, event);
	handleOnRemoveDeelnamePrijs = (index, event) => this.pageHelper.removeDeelnamePrijs(index, event);
	handleOnAddDeelnamePrijs = () => this.pageHelper.addDeelnamePrijs();
	handleOnChangeExtraOndersteuning = event => this.pageHelper.changeExtraOndersteuning(event);
	handleOnChangeLus = (index, event) => this.pageHelper.changeLus(index, event);
	handleOnRemoveLus = (index, event) => this.pageHelper.removeLus(index, event);
	handleOnAddGemeente = (index, event) => this.pageHelper.addGemeente(index, event);
	handleOnChangeGemeente = (index, event) => this.pageHelper.changeGemeente(index, event);
	handleOnRemoveGemeente = (index, event) => this.pageHelper.removeGemeente(index, event);
	handleOnAddLus = () => this.pageHelper.addLus();
	handleOnGetGeoCoordinatesStart = () => this.pageHelper.getGeoCoordinatesStart(event);
	handleOnGetGeoCoordinatesAankomst = () => this.pageHelper.getGeoCoordinatesAankomst(event);
	handleOnGetError = (propertyName, childModelName) => this.pageHelper.getErrorForProperty(propertyName);
	handleOnConfirmAnbPopup = () => this.pageHelper.confirmAnbPopup();
	handleOnMarkerDragEnd = (event, id) => this.pageHelper.markerDragEnd(event, id);
	isReadyToRender = () => {
		return this.props.landen &&
			this.props.postcodes &&
			this.props.gemeenten &&
			this.state.hoofdgemeenten &&
			this.state.hoofdgemeenten.length > 0 &&
			!!this.filesHelper;
	};

	render() {
		if (!this.isReadyToRender()) return null;
		const state = this.state;
		const props = this.props;
		const model = state.model;
		const hoofdgemeenten = state.hoofdgemeenten;
		const disabled = props.disabled;
		const showAnbPopup = state.showAnbPopup;
		const showVoorzieningenPopup = state.showVoorzieningenPopup;
		const osmBaseLayerUrl = props.osmBaseLayerUrl;
		const mapId = state.mapId;
		const color = types.COLOR_TURQUOISE_DARK;
		const fileComponents = state.fileComponents;
		// const svlDossierId = state.svlDossierId;
		const draaiboekFileTypes = props.draaiboekFileTypes;
		const downloadFileUrl = this.filesHelper.getFileDownloadUrl();
		return (
			<Section
				title={"Gegevens van de tocht"}
				color={types.COLOR_TURQUOISE_DARK}
			>
				<UpdateTochtForm
					model={model}
					onChange={this.handleOnChange}
					onChangeStartplaats={this.handleOnChangeStartplaats}
					onChangeRadio={this.handleOnChangeRadio}
					onSave={this.handleOnSave}
					getError={this.handleOnGetError}
					disabled={disabled}
					readonly={false}
					onChangeDeelnamePrijs={this.handleOnChangeDeelnamePrijs}
					onRemoveDeelnamePrijs={this.handleOnRemoveDeelnamePrijs}
					onAddDeelnamePrijs={this.handleOnAddDeelnamePrijs}
					onChangeExtraOndersteuning={this.handleOnChangeExtraOndersteuning}
					onChangeLus={this.handleOnChangeLus}
					onRemoveLus={this.handleOnRemoveLus}
					onAddLus={this.handleOnAddLus}
					onAddGemeente={this.handleOnAddGemeente}
					onChangeGemeente={this.handleOnChangeGemeente}
					onRemoveGemeente={this.handleOnRemoveGemeente}
					onGetGeoCoordinatesStart={this.handleOnGetGeoCoordinatesStart}
					onGetGeoCoordinatesAankomst={this.handleOnGetGeoCoordinatesAankomst}
					landen={this.props.landen}
					gemeenten={this.props.gemeenten}
					hoofdgemeenten={hoofdgemeenten}
					postcodes={this.props.postcodes}
					validationMessageType={this.state.validationMessageType}
					showAnbPopup={showAnbPopup}
					showVoorzieningenPopup={showVoorzieningenPopup}
					onConfirmAnbPopup={this.handleOnConfirmAnbPopup}
					osmBaseLayerUrl={osmBaseLayerUrl}
					onMarkerDragEnd={this.handleOnMarkerDragEnd}
					mapId={mapId}
					color={color}
					draaiboekFileTypes={draaiboekFileTypes}
					onDrop={this.handleOnUploadFiles}
					onDelete={this.handleOnDeleteFile}
					fileComponents={fileComponents}
					downloadFileUrl={downloadFileUrl}
				/>
			</Section>
		);
	}
}

UpdateTochtPage.propTypes = {
	loadLayout: PropTypes.func
};

function mapStateToProps(state) {
	const landen = state.referentie.landen;
	const gemeenten = state.referentie.gemeenten;
	const postcodes = state.referentie.postcodes;
	const disabled = state.settings.disabled;
	const shouldRedirect = !state.layout.topNavTabsSet;
	const draaiboekFileTypes = state.settings.fileTypes[types.FileComponentNames.DRAAIBOEK_CORONA_MAATREGELEN];
	const svlDossierId = state.settings.svlDossierId;

	return {
		landen: landen,
		gemeenten: gemeenten,
		postcodes: postcodes,
		disabled: disabled,
		shouldRedirect: shouldRedirect,
		osmBaseLayerUrl: state.settings.osmBaseLayerUrl,
		draaiboekFileTypes: draaiboekFileTypes,
		svlDossierId: svlDossierId
	};
}

function mapDispatchToProps(dispatch, ownProps) {
	return {
		loadLayout: bindActionCreators(layoutActions.loadUpdateTochtPageLayout, dispatch),
		validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
		ajaxActions: bindActionCreators(ajaxActions, dispatch),
		throwException: bindActionCreators(throwException, dispatch)
	};
}

export default connect(
	mapStateToProps, mapDispatchToProps)(UpdateTochtPage);
